import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import API from "@/lib/api";
import { geocode } from "@/lib/geo";
import { ArrowLeft, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const RADII = [5, 15, 30, 50, 100, "all"];

export default function Zone() {
  const navigate = useNavigate();
  const [zone, setZone] = useState({ start_point: {}, general_radius: 30, offer_online: true, per_category_radius: {} });
  const [cityQuery, setCityQuery] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    API.get("/me/full").then((r) => {
      if (r.data.zone) { setZone(r.data.zone); setCityQuery(r.data.zone.start_point?.city || ""); }
    }).catch(() => {});
  }, []);

  const searchCity = async () => setResults(await geocode(cityQuery));

  const save = async () => {
    await API.put("/me/zone", {
      country: "IT", start_point: zone.start_point, general_radius: zone.general_radius,
      offer_online: zone.offer_online, per_category_radius: zone.per_category_radius || {},
    });
    toast.success("Zona salvata");
    navigate("/");
  };

  return (
    <Layout>
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-[#4A4E68] mb-3 text-sm"><ArrowLeft size={16} /> Indietro</button>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-4">Zona</h1>

      <div className="bg-white rounded-[18px] border border-[#DADFEA] p-5 space-y-5">
        <div>
          <p className="text-sm font-medium text-[#0F1230] mb-1">Punto di partenza</p>
          <div className="flex gap-2">
            <Input data-testid="zone-city-input" placeholder="Città o indirizzo" value={cityQuery} onChange={(e) => setCityQuery(e.target.value)} />
            <Button type="button" onClick={searchCity} variant="outline" className="rounded-full shrink-0"><Search size={16} /></Button>
          </div>
          {results.length > 0 && (
            <div className="mt-2 border border-[#DADFEA] rounded-xl overflow-hidden">
              {results.map((r, i) => (
                <button key={i} onClick={() => { setZone({ ...zone, start_point: { city: r.city, lat: r.lat, lng: r.lng } }); setCityQuery(r.city); setResults([]); }}
                  className="block w-full text-left px-3 py-2 text-sm hover:bg-[#EEF1F7] border-b border-[#DADFEA] last:border-0">{r.label}</button>
              ))}
            </div>
          )}
          {zone.start_point?.city && <p className="text-xs text-[#2E7D32] mt-1">{zone.start_point.city}</p>}
        </div>

        <div>
          <p className="text-sm font-medium text-[#0F1230] mb-2">Raggio generale</p>
          <div className="flex flex-wrap gap-2">
            {RADII.map((r) => (
              <button key={r} data-testid={`radius-${r}`} onClick={() => setZone({ ...zone, general_radius: r })}
                className={`px-3 h-10 rounded-full text-sm border ${zone.general_radius === r ? "bg-[#1F4FE0] text-white border-[#1F4FE0]" : "border-[#DADFEA]"}`}>
                {r === "all" ? "Tutto il paese" : `${r} km`}
              </button>
            ))}
          </div>
        </div>

        <label className="flex items-center justify-between">
          <span className="text-sm text-[#2A2E48]">Offro anche servizi online</span>
          <Switch data-testid="offer-online-switch" checked={zone.offer_online} onCheckedChange={(v) => setZone({ ...zone, offer_online: v })} />
        </label>

        <Button data-testid="zone-save" onClick={save} className="w-full h-12 bg-[#FFD23F] hover:bg-[#F2C200] text-[#0F1230] rounded-full">Salva zona</Button>
      </div>
    </Layout>
  );
}
